import React, { useEffect, useState } from 'react'
import logo from '../pictures/TheBestescafflogo.png'
import Sidebar from '../components/Sidebar'
import FourButtons from '../components/FourButtons'
import { Switch, CircularProgress, useMediaQuery } from '@mui/material';
import outro from '../pictures/outro.png'
import { useDispatch, useSelector } from 'react-redux';
import { addTemproryRoofAdaoptionQoute, addTemproryRoofQoute, adminActions, fetchPriceList, fetchSingleJob, fetchTemproryRoofAdaptionQoutation, fetchTemproryRoofQoutation, signOut } from '../store/adminSlice';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import escapeHtml from '../functions/Validator';
import Swal from 'sweetalert2';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import IconButton from '@mui/material/IconButton';
import HeaderScaff from '../components/HeaderScaff';
import CircleIcon from '@mui/icons-material/Circle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';

function TemporaryRoofAdaptionQuotes() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [ sidebarOpen, setSidebarOpen ] = useState(true);
  const [needed, setNeeded] = useState(false);
  const _id=useSelector((state)=>state.admin._id)
  const navigate=useNavigate();

  const dispatch=useDispatch();

  const queryParameters = new URLSearchParams(window.location.search)

  const id = queryParameters.get("id")
  const adaptionID = queryParameters.get("adaptionID")
  const stateSingleJob=useSelector((state)=>state.admin.singleJob)
  const StateTemporaryRoofQoutation = useSelector((state) => state.admin.temporaryRoofAdaptionQoutation)
  const escaffQuotationSwalAlert=useSelector((state)=>state.admin.swalAlert)
  const [data, setData] = useState(StateTemporaryRoofQoutation)
  const [result, setResult] = useState(0)
  const statesignOut=useSelector((state)=>state.admin.signOut)
  const onChangeDate = e => {
    const newDate = moment(new Date(e.target.value)).format('YYYY-MM-DD');
    setData({ ...data, dateOfErection: newDate ,nextInspectionDate:newDate, customerID: stateSingleJob.customer._id,jobID:stateSingleJob._id,adaptionID:adaptionID})
    // setData({ ...data, customerID: stateSingleJob.customer._id })
  };
  useEffect(() => {
    if (statesignOut==="signOut") {
        dispatch(signOut())
    }
},[statesignOut])
  useEffect(() => {
   
    if(id){
        dispatch(fetchSingleJob({_id:id,adminID:_id}))
        dispatch(fetchPriceList({adminID:_id}))
    }else{
        navigate("/pendingprojectqoutes")
    }
    
  }, [])
  const subscribed=useSelector((state)=>state.admin.subscribed);
    useEffect(() => {
      if(!_id){
        navigate("/signin")
      } else if (!subscribed) {
        navigate("/signin")
        
      }
    },[])
  useEffect(() => {
    if(escaffQuotationSwalAlert.message==="Saved"){
        Swal.fire({
            icon: 'success',
            title: 'Saved',
            confirmButtonColor:"#60c088",
            }).then(() => {
                dispatch(adminActions.removeSwalAlert());
                window.location.reload();
            })
    }
    if(escaffQuotationSwalAlert.message==="updatedEscaff") {
        Swal.fire({
            icon: 'success',
            title: 'Updated',
            confirmButtonColor:"#60c088",
        }).then(() => {
            dispatch(adminActions.removeSwalAlert());
            window.location.reload();
        })
    }
  }, [escaffQuotationSwalAlert])
  useEffect(() => {
    dispatch(fetchTemproryRoofAdaptionQoutation({adaptionID:adaptionID,adminID:_id}))
    dispatch(adminActions.removeSwalAlert());
  }, [])
  useEffect(()=>{
    if(!window.location.hash) {
        // console.log("one");
        window.location = window.location + '#loaded';
        window.location.reload();
    }
    
},[])
  useEffect(() => {
    setData(StateTemporaryRoofQoutation)
  },[StateTemporaryRoofQoutation])

  const handleSubmit = () => {
    if(data.dateOfErection===""||data.adaptionCost===0){
      Swal.fire({
          icon: 'error',
          title: 'Oops...',
          confirmButtonColor:"#60c088",
          text: 'Kindly calculate first.!',
        })
    } else {
      
      console.log(data);
    dispatch(addTemproryRoofAdaoptionQoute(data));
  }
  }
  return (
    <div className="w-full flex flex-col h-full bg-gray-50">
      {/* Header with back and close buttons */}
      <div className="w-full bg-white shadow-md px-4 py-3 flex justify-between items-center sticky top-0 z-40">
        <div className="flex items-center">
          <button
            onClick={() => navigate(-1)}
            className="mr-3 text-gray-700 hover:text-lightgreen transition-colors"
          >
            <ArrowBackIcon />
          </button>
          <img src={logo} alt="Escaff Logo" className="h-10" />
        </div>
        <button
          onClick={() => navigate("/pendingprojectqoutes")}
          className="text-gray-500 hover:text-lightgreen transition-colors"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h2 className="text-lg sm:text-xl font-medium text-gray-800 mb-6">
            Temporary roof quote
          </h2>

          <div className="flex flex-col lg:flex-row gap-6">
            {/* Left Column - Form */}
            <div className="w-full lg:w-1/2">
              <div className="space-y-6">
                {/* Date of Adaption */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Date of Adaption
                  </label>
                  <input 
                    className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                    value={data.dateOfErection} 
                    type="date"
                    onChange={onChangeDate} 
                    required
                  />
            </div>

                {/* Adaption Cost */}
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    Adaption Cost
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span className="text-gray-700">£</span>
                    </div>
                    <input 
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full pl-8 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) => setData({...data, totalCostResult: e.target.value})} 
                      value={data.totalCostResult} 
                      type="number" 
                      onWheel={(e) => e.target.blur()} 
                      required
                    />
        </div>
        </div>
        
                {/* Submit Button */}
                <div className="pt-6">
                  <button
                    onClick={handleSubmit}
                    className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column - Job Details */}
            <div className="w-full lg:w-1/2">
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <div className="p-6">
                  <img src={outro} alt="" className="w-full h-auto object-contain mb-6" />
                  
                  <div className="space-y-6">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">Job Description</h3>
                      <p className="text-gray-600">{stateSingleJob.jobDescription}</p>
                    </div>
                    
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">Job Access</h3>
                      <p className="text-gray-600">{stateSingleJob.jobDetails}</p>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
</div>
  );
}

export default TemporaryRoofAdaptionQuotes;